/*
    Тип узла (префикс System необходим, чтобы не спутать со встроенным классом)
*/
export enum SystemNodeType {
  Company = 'company', // Компания
  Facility = 'facility', // Завод
  Workshop = 'workshop', // Цех
  Machine = 'machine', // Станок
  MachineUnit = 'machine_unit', // Узел станка
  Other = 'other', // Другой
}

/*
    Агрегированный статус работы станка
*/
export enum MachineWorkingStatus {
  Off = 0, // Выключено
  Idle = 1, // Холостой режим
  Work = 2, // Рабочий режим
  Incorrect = 3, // Системная ошибка
}
